/**
 * Umbrella experiment (Conductor, ADR-0009): creates the editor VSM engine and its dual writes, and swaps
 * the editor's CSS from catharsis to the signals CSS engine. Converts no feature on its own.
 */
export const VSM_EDITOR_EXPERIMENT = 'vsmEditorCore' as const

/**
 * Single conversion experiment (Conductor, ADR-0009): converts every registered editor feature, the
 * platform surface included, from Carmi to VSM. Only effective together with `VSM_EDITOR_EXPERIMENT`.
 */
export const VSM_EDITOR_CONFIGS_EXPERIMENT = 'vsmEditorFeatures' as const

/**
 * @deprecated The platform surface no longer has its own spec (ADR-0009 supersedes ADR-0007); this is the
 * same value as `VSM_EDITOR_CONFIGS_EXPERIMENT`. Use that instead.
 */
export const VSM_EDITOR_PLATFORM_EXPERIMENT = VSM_EDITOR_CONFIGS_EXPERIMENT

/**
 * Not a VSM conversion spec — it gates the `platform-ds` Carmi-free refactor (#50085) — but it lives
 * here because it is a **precondition of the conversion spec**. `createBootstrapData` keeps reading
 * Carmi's `siteFeaturesConfigs` aggregate while the Carmi-free path is off, and the `*WixCodeSdk` site
 * configs leave that aggregate as soon as the editor features convert. `platform-ds` therefore takes the
 * Carmi-free path whenever this is open **or** the editor features are VSM-served, so the SDK factories
 * are never handed nothing.
 */
export const PLATFORM_DS_CARMI_FREE_EXPERIMENT = 'platformDsCarmiFree' as const
